/**
 * Who is signed in.
 *
 * Two different ids come out of a customer sign-in and they are easy to mix
 * up, which is what the reports kept doing:
 *
 *   - the LOGIN ID - what the customer types on the login screen. The reports
 *     send it as `code`. The login screen saves it as `user-id`, because the
 *     AuthTokenCust response does not echo it back.
 *   - `user-info.userId` - the internal account id from that response, which
 *     comes back as the client/firm id and is what `OwnAppConfigs/{id}` wants.
 *     It is NOT the login id.
 *
 * Read the login id through here rather than reaching into localStorage at
 * each call site, so the two cannot be confused again.
 */

export const getUserInfo = () => {
    try {
        return JSON.parse(localStorage.getItem('user-info')) || null;
    } catch (err) {
        return null;
    }
};

/** The id the customer signed in with - what reports send as `code`. */
export const getLoginId = () => {
    const typed = localStorage.getItem('user-id');

    if (typed) {
        return typed;
    }

    const user = getUserInfo();

    return (user && (user.userName || user.loginId || user.code)) || '';
};

/** The internal account id - for OwnAppConfigs/{id}, never for `code`. */
export const getAccountId = () => {
    const user = getUserInfo();

    return (user && user.userId) || localStorage.getItem('user-id') || '';
};

export default getLoginId;
